import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-42ba94d0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left-curve"
};
const _hoisted_2 = {
  width: "7",
  height: "6",
  viewBox: "0 0 7 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_3 = ["fill"];
const _hoisted_4 = ["stroke"];
const _hoisted_5 = {
  class: "right-curve"
};
const _hoisted_6 = {
  width: "7",
  height: "6",
  viewBox: "0 0 7 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_7 = ["fill"];
const _hoisted_8 = ["stroke"];
const _hoisted_9 = {
  style: {
    "padding": "10px 24px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pause_in_circle_icon = _resolveComponent("pause-in-circle-icon");
  const _component_play_3d_icon = _resolveComponent("play-3d-icon");
  const _component_b_button = _resolveComponent("b-button");
  const _component_loading_element = _resolveComponent("loading-element");
  const _component_app_modal = _resolveComponent("app-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_loading_element, {
    loading: $data.loading,
    size: "260",
    height: 30
  }, {
    default: _withCtx(() => [_createVNode(_component_b_button, {
      onClick: $options.handleClick,
      class: _normalizeClass(['ppc-automation-controller', $props.status])
    }, {
      default: _withCtx(() => [$options.enabled ? (_openBlock(), _createBlock(_component_pause_in_circle_icon, {
        key: 0
      })) : (_openBlock(), _createBlock(_component_play_3d_icon, {
        key: 1
      })), _createElementVNode("span", null, _toDisplayString($data.texts[$props.status] ?? 'Unknown'), 1), _createElementVNode("div", _hoisted_1, [(_openBlock(), _createElementBlock("svg", _hoisted_2, [_createElementVNode("path", {
        d: "M0 6H7V3V0C6.5 0.00040935 6.5 0 6 0C5.5 3 2.4083 6 0 6Z",
        fill: $options.enabled ? '#F0F6FF' : '#FAFAFA'
      }, null, 8, _hoisted_3), _createElementVNode("path", {
        d: "M6 0C6 2.5 2.8 5.5 0 5.5",
        stroke: $options.enabled ? '#ADCDFF' : '#E3E3E3',
        "stroke-width": "1.75"
      }, null, 8, _hoisted_4)]))]), _createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock("svg", _hoisted_6, [_createElementVNode("path", {
        d: "M7 6H0V3V0C0.5 0.00040935 0.5 0 1 0C1.5 3 4.5917 6 7 6Z",
        fill: $options.enabled ? '#F0F6FF' : '#FAFAFA'
      }, null, 8, _hoisted_7), _createElementVNode("path", {
        d: "M1 0C1 2.5 4.2 5.5 7 5.5",
        stroke: $options.enabled ? '#ADCDFF' : '#E3E3E3',
        "stroke-width": "1.75"
      }, null, 8, _hoisted_8)]))])]),
      _: 1
    }, 8, ["onClick", "class"])]),
    _: 1
  }, 8, ["loading"]), _createVNode(_component_app_modal, {
    modelValue: $data.changeModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.changeModal = $event),
    title: "Confirm PPC Automation Status Update",
    "cancel-title": "No",
    "ok-title": "Yes",
    onOk: _cache[1] || (_cache[1] = () => {
      this.enabled ? _ctx.$emit('pause') : _ctx.$emit('enable');
      this.loading = true;
      this.changeModal = false;
    }),
    custom_class: "confirm-block-modal"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createTextVNode(" Are you sure you want to "), _createElementVNode("b", null, _toDisplayString(this.enabled ? "PAUSE" : "ENABLE"), 1), _createTextVNode(" Budget and Bidding Automation on this profile ? ")])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}